import moment from 'moment';
import { OrderTypeMap } from '@intelligence/pages/InsightsReport/components/SortBySelector';

/**
 * 报告根据排序选项排序
 *
 * @param {*} data
 * @param {string} orderType
 * @returns {*}
 */
export const sortReportsData = (data: any, orderType: string) => {
  return data
    ?.sort((a: any, b: any) => {
      const createTimeSort =
        moment(b.create_time || b.time).valueOf() - moment(a.create_time || a.time)?.valueOf();

      // 点赞排序，如果点赞数相同使用时间排序
      if (orderType === OrderTypeMap.likes) {
        return a.report_like === b.report_lie ? createTimeSort : b.report_like - a.report_like;
      }

      // 浏览排序，如果点赞数相同使用时间排序
      if (orderType === OrderTypeMap.views) {
        return a.watched_cnt === b.watch_cn ? createTimeSort : b.watched_cnt - a.watched_cnt;
      }

      // 创建时间排序
      return createTimeSort;
    })
    .map((item: any, index: number) => ({ ...(item || {}), key: index }));
};
